export default __webpack_public_path__ + "static/media/sun-svgrepo-com.d4369dd5.svg";